import { PERMISSION } from '@/app/permissions';

/**
 * Who may reach the register of funding applications, and who may take a copy of one.
 *
 * Two codes each, because the backend's own guards are an `or`: AIPA holds `applications.read:any`
 * and `applications.download:any`, MAIA_ADMIN holds `applications.approve:any`, and neither holds
 * the other's. Written once and read by the sidebar entry, the route guard and the download button
 * so the three cannot drift — a menu item that leads to a screen that refuses, or a button whose
 * request comes back 403, are both the same mistake made in one of the three places.
 */
export const APPLICATIONS_READ_ANY = [
  PERMISSION.applicationsReadAny,
  PERMISSION.applicationsApproveAny,
] as const;

export const APPLICATIONS_DOWNLOAD_ANY = [
  PERMISSION.applicationsDownloadAny,
  PERMISSION.applicationsApproveAny,
] as const;
